<template>
    <footer class="footer footer-layout1 text-center bg-dark">
      <div class="footer-top">
        <div class="container">
          <div class="row align-items-center">
            <div class=" col-12">
              <div class="contact-box">
                <h6 class="contact__box-title">{{ menu.locationName }}</h6>
                <ul class="contact__box-list list-unstyled">
                  <li>
                        {{menu.address1}}<br>
                        {{menu.address2}}<br>
                        {{menu.city}}<br>
                  </li>
                </ul>
              </div>
             <p class="mx-2 mb-20">Creado por losplatos.es. Crea tu menú aquí</p>
            </div>
            <div class="col-12">
              <img id="logoImage" v-bind:src=menu.businessLogo>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    name: 'MenuFooter',
    props: ['menu']
}
</script>


<style>

</style>